<template>
    <VTooltip
        direction="top"
        maxWidth="none"
        hoverBridge
    >
        <VButton
            ref="badgeRef"
            v-gtm:label="gtmLabel"
            v-gtm:@click
            data-testid="score-prediction-promotion-badge"
            class="scorePredictionPromotionBadge"
            v-on:click="openEventPage"
        >
            <SboIcon name="system:gift" size="xs" />
            <span class="scorePredictionPromotionBadge_label">{{ i18n.t('score_prediction_badge_label') }}</span>
        </VButton>
        <template #content>
            <I18nT keypath="score_prediction_badge_tooltip">
                <template #viewDetails>
                    <u
                        class="scorePredictionPromotionBadge_tooltipLink"
                        data-testid="score-prediction-promotion-view-details"
                        v-on:click="openEventPage"
                    >{{ i18n.t('score_prediction_badge_tooltip_view_details') }}</u>
                </template>
            </I18nT>
        </template>
    </VTooltip>
</template>

<script lang="ts" setup>
    import { ref, toRefs } from 'vue';
    import SboIcon from '@/components/common/SboIcon.vue';
    import VButton from '@/components/common/button/VButton.vue';
    import { useScorePredictionPromotion } from '@/composable/useScorePredictionPromotion';
    import type { ScorePredictionPromotionGtmLabel } from '@/composable/useScorePredictionPromotionViewTracking';
    import { useScorePredictionPromotionViewTracking } from '@/composable/useScorePredictionPromotionViewTracking';
    import { i18n } from '@/core/lib/i18n';
    import { VTooltip } from '@/directives/tooltip';

    const props = defineProps<{
        gtmLabel: ScorePredictionPromotionGtmLabel;
        /** Tells this icon apart from the other badges on the page, for the once-per-page-load view event. */
        iconId: string;
    }>();
    const { gtmLabel, iconId } = toRefs(props);

    const { openEventPage } = useScorePredictionPromotion();

    const badgeRef = ref<InstanceType<typeof VButton> | null>(null);
    useScorePredictionPromotionViewTracking(() => badgeRef.value?.elementRef ?? null, gtmLabel, iconId);
</script>

<style lang="scss" scoped>
    @import "@/components/promotion/ScorePredictionPromotionBadge";
</style>
